// extracted by mini-css-extract-plugin
export default {"wrapper":"SideNavigation_wrapper__A-axe","nav":"SideNavigation_nav__ObntO","active":"SideNavigation_active__jFOBz","navLink":"SideNavigation_navLink__rwAGV"};